/**
 * Handles the JS logic of overlay images on product cards.
 *
 * @see Product_Card::maybe_add_overlay_image
 */

class overlayImages {
	constructor() {
		// Here we add an action that we will use to trigger the setup of this functionality.
		// This allows us to run wp.hooks.doAction( 'qala_theme/action/do_wc_overlay_images' ); from anywhere in our codebase and it'll apply the listeners to the products it find.
		wp.hooks.addAction( 'qala_theme.action.do_product_overlay_images', 'qala_theme', this.setup, 10 );

		// Make the class we add on hover filterable so that child themes can change it if necessary.
		this.hoverClass = wp.hooks.applyFilters( 'qala_theme.filter.product_overlay_images_hover_class', 'hover' );

		// Document ready.
		document.defaultView.addEventListener( 'load', this.actions );
	}

	/**
	 * Handles triggering any actions.
	 */
	actions = () => {
		wp.hooks.doAction( 'qala_theme.action.do_product_overlay_images' );
	};

	/**
	 * Sets up the whole logic with the event listeners on product images.
	 */
	setup = () => {
		const productElements = wp.hooks.applyFilters( 'qala_theme.filter.product_overlay_images', document.querySelectorAll( '.product-card__images' ) );

		if ( ! productElements ) {
			return;
		}

		productElements.forEach( product => {
			// Get the parent.
			const productCard = product.closest( '.product-card' );

			if ( ! productCard ) {
				return;
			}

			// Listen to mouseover to show overlay image.
			productCard.addEventListener( 'mouseenter', event => {
				const overlayWrapper = event.currentTarget.querySelector( '.product-card__overlay-image' );
				// Only do this if the overlay image div wrapper was found. Prevents attempting to do this on products without overlay images.
				if ( overlayWrapper ) {
					this.showOverlayImage( overlayWrapper );
				}
			} );

			// Listen to mouseout to hide overlay image.
			productCard.addEventListener( 'mouseleave', event => {
				const overlayWrapper = event.currentTarget.querySelector( '.product-card__overlay-image' );
				if ( overlayWrapper ) {
					this.hideOverlayImage( overlayWrapper );
				}
			} );
		} );
	};

	/**
	 * Grabs any source and img elements within the wrapper, gets their attributes sorted and then adds the hover class and removes inline styles.
	 *
	 * @param {Node} overlayWrapper
	 */
	showOverlayImage = overlayWrapper => {
		const sourceElements = overlayWrapper.querySelectorAll( 'source' );
		this.restoreSourceElements( sourceElements );

		const imgElement = overlayWrapper.querySelector( 'img' );
		this.restoreImg( imgElement );

		// Add a slight timeout before actually showing the image to allow it to be fetched first. This ensures that our CSS transitions look smooth every time.
		setTimeout( () => {
			overlayWrapper.classList.add( this.hoverClass );
			overlayWrapper.removeAttribute( 'style' );
		}, 100 );
	};

	/**
	 * Assignes all data-srcset attributes as srcset attributes on any <source> element.
	 *
	 * @param {NodeList} sourceElements
	 */
	restoreSourceElements = sourceElements => {
		if ( ! sourceElements ) {
			return;
		}

		sourceElements.forEach( sourceElement => {
			if ( sourceElement.dataset.srcset ) {
				sourceElement.srcset = sourceElement.dataset.srcset;
			}
		} );
	};

	/**
	 * Assignes any data-srcset to srcset and data-src to src attributes on the <img> element.
	 *
	 * @param {Node} imgElement
	 */
	restoreImg = imgElement => {
		if ( ! imgElement ) {
			return;
		}
		if ( imgElement.dataset.srcset ) {
			imgElement.srcset = imgElement.dataset.srcset;
		}

		if ( imgElement.dataset.src ) {
			imgElement.src = imgElement.dataset.src;
		}
	};

	/**
	 * Removes the hover class from the overlay wrapper element.
	 *
	 * @param {Node} overlayWrapper
	 */
	hideOverlayImage = overlayWrapper => {
		// Set a delay slightly longer than the one for show to avoid race conditions between show/hide on quick mouse movements.
		setTimeout( () => {
			overlayWrapper.classList.remove( this.hoverClass );
		}, 120 );
	};
}

export default overlayImages;
